// extracted by mini-css-extract-plugin
module.exports = {"img":"HouseProfImg_img__3mowf","hoverImg":"HouseProfImg_hoverImg__1LVLe","loadingImg":"HouseProfImg_loadingImg__3RUK5"};